import React, { useState, useRef, useEffect } from "react";
import rivalSendIcon from "./icons/rival-send-icon.svg";
import { CHAR_WARNING_THRESHOLD, INPUT_CHARS_LIMIT, PERFORMANCE_CHARS_LIMIT } from "./utils";
import { HelpType } from "./products";

const Input = ({ handleSend, isLoading, helpType }) => {
  const [input, setInput] = useState('');
  const textareaRef = useRef(null);
  const charLimit = helpType === HelpType.PERFORM ? PERFORMANCE_CHARS_LIMIT : INPUT_CHARS_LIMIT;

  useEffect(() => {
    if (!isLoading && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [isLoading]);

  useEffect(() => {
    const focusTextarea = () => {
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
    };

    const timeoutId = setTimeout(focusTextarea, 300);
    return () => clearTimeout(timeoutId);
  }, []);

  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  const handleInputChange = (e) => {
    setInput(e.target.value);
    adjustTextareaHeight();
  };

  const sendQuery = (e, type = 'default') => {
    if (input.length <= charLimit && input.trim()) {
      if((e.key === "Enter" && !e.shiftKey) || type === 'icon') {
        e.preventDefault?.();
        handleSend(input);
        setInput('');
        setTimeout(() => adjustTextareaHeight(), 0);
      }
    }
  }

  return (
    <div className="chat-input-container tw-p-4 tw-flex tw-flex-col tw-items-center tw-relative">
      <div className="tw-relative tw-flex-1 tw-w-full">
        <textarea
          ref={textareaRef}
          id="chat-input"
          className={`tw-block tw-w-full tw-rounded-md tw-border-0 tw-m-0 tw-p-4 ${isLoading ? 'tw-bg-rivallightgrey' : 'tw-bg-white'} tw-text-rivalsoftblack tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-electric placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-electric tw-text-sm sm:tw-leading-4 tw-outline-none tw-resize-none tw-overflow-y-auto tw-max-h-40 ${input.length <= charLimit ? "tw-pr-10" : "tw-pr-4"}`}
          value={input}
          onChange={handleInputChange}
          onKeyDown={sendQuery}
          placeholder={isLoading ? "Please wait." : "Ask me anything!"}
          rows="1"
          maxLength={charLimit + 1}
          disabled={isLoading}
        />
        {input && input.length <= charLimit && (
          <img
            src={rivalSendIcon}
            onClick={() => sendQuery('','icon')}
            alt="Send Icon"
            className={`tw-block tw-absolute tw-right-4 tw-top-[10px] -tw-rotate-90 tw-cursor-pointer tw-text-white tw-bg-rivalcharcoal tw-p-1 tw-rounded-full tw-size-7 ${isLoading ? "tw-opacity-50 tw-cursor-not-allowed" : ""}`}
          />
        )}
        {charLimit - input.length >= 0 &&
          charLimit - input.length <= CHAR_WARNING_THRESHOLD && (
            <span className="tw-absolute tw-bottom-0 tw-right-2 tw-p-2 tw-text-xs tw-text-rivalgrey">
              {charLimit - input.length}
            </span>
          )}
      </div>
      {charLimit - input.length < 0 && (
        <span className="tw-mt-2 tw-text-xs tw-text-red-600">
          This message is too long!
        </span>
      )}
    </div>
  );
};

export default Input;
